import { Component, OnInit } from '@angular/core';

import { LoginService } from "../../services/login.service";
import { emptyPerson, IPerson } from "../../model/person";
import { environment } from "../../../environments/environment";
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-mng-header',
  templateUrl: './mng-header.component.html',
  styleUrls: ['./mng-header.component.css']
})
export class MngHeaderComponent implements OnInit {

  environmentPrefix: string = environment.prefix;

  /**
   * Usuario logueado
   */
  person: IPerson = emptyPerson;

  swClientActive: boolean;

  constructor(
    private loginService: LoginService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.swClientActive = this.route.snapshot.url[0].path === 'cliente';
    this.loginService.person$
      .subscribe(person => this.person = person);
  }

  logout() {
    this.loginService.logout();
    this.loginService.redirectToHome();
  }
}



// WEBPACK FOOTER //
// ./src/app/app-manager/mng-header/mng-header.component.ts